export const STORE_FORM_VALUES = 'FNV/STORE_FORM_VALUES';
export const CLEAR_FORM_VALUES = 'FNV/CLEAR_FORM_VALUES';
export const FILL_FORM_VIA_API = 'FNV/FILL_FORM_VIA_API';
export const ERROR_FORM_GETAPI = 'FNV/ERROR_FORM_GETAPI';
export const CLEAR_ERROR_FORM_GETAPI = 'FNV/CLEAR_ERROR_FORM_GETAPI';
export const ERROR_FORM_MESSAGE = 'FNV/ERROR_FORM_MESSAGE';
export const CLEAR_ERROR_FORM_MESSAGE = 'FNV/CLEAR_ERROR_FORM_MESSAGE';

export const STORE_ALERT = 'FNV/STORE_ALERT';
export const CLEAR_ALERTS = 'FNV/CLEAR_ALERTS';

export const GET_ALERTS_BY_API = 'FNV/GET_ALERTS_BY_API';

export const STORE_STEP = 'FNV/STORE_STEP';
export const CLEAR_STEPS = 'FNV/CLEAR_STEPS';
export const SET_ACTIVE_STEP = 'FNV/SET_ACTIVE_STEP';
export const STORE_EXTRA_STEP = 'FNV/STORE_EXTRA_STEP';
export const CLEAR_EXTRA_STEPS = 'FNV/CLEAR_EXTRA_STEPS';

export const CLEAR_USER = 'FNV/CLEAR_USER';
export const STORE_USER = 'FNV/STORE_USER';

export const STORE_RENDER_FORM_TRIGGER = 'FNV/STORE_RENDER_FORM_TRIGGER';
export const CLEAR_RENDER_FORM_TRIGGER = 'FNV/CLEAR_RENDER_FORM_TRIGGER';

export const LOGIN_URL = '/login';

export const MIJNFNV_SITEMAP_URL = '/api/mijnfnvsitemap';
export const MIJNFNV_SETTINGS_URL = '/api/mijnfnvsettings';
export const MIJNFNV_POPUPS_URL = '/api/mijnfnvpopup';

export const MIJNFNV_CLAIMS_URL = '/api/mijnfnv/getclaims';
export const MIJNFNV_MONTLYFEE_URL = '/api/esb/contributiesbetaalinformatie';
export const MIJNFNV_STARTTRANSACTION_URL = '/api/esb/starttransaction';
export const MIJNFNV_LIDZOEKEN_STORECONSENT_URL = '/api/lidzoeken';
export const MIJNFNV_DOSSIER_URL = '/api/esb/dossieroverzicht'; 

export const IDEAL_STATUS_URL = '/api/ideal/getstatusforperson';

export const STORE_RESULT_LIDZOEKEN = 'FNV/STORE_RESULT_LIDZOEKEN';
export const CLEAR_LIDZOEKEN = 'FNV/CLEAR_LIDZOEKEN';
export const START_LIDZOEKEN = 'FNV/START_LIDZOEKEN';
export const STOP_LIDZOEKEN = 'FNV/STOP_LIDZOEKEN';
export const SET_CONSENT_LIDZOEKEN = 'FNV/SET_CONSENT_LIDZOEKEN';
export const PASSTHROUGH_FIELD_LIDZOEKEN = 'FNV/PASSTHROUGH_FIELD_LIDZOEKEN';

export const ACCOUNT_AANMAKEN_URL = '/mijn-fnv/mijn-fnv-account-aanmaken';

export const KenticoMijnFNVOverzichtPageType = 'FNV.MijnFnvOverzicht';
export const FrontendDashboardPageType = 'dashboard';

export const KenticoMijnFNVEditPageType = 'FNV.MijnFnvEditPagina';
export const KenticoMijnFNVViewPageType = 'FNV.MijnFnvViewPagina';

export const MAX_POSTDATA_SIZE = 4100000;
